import { Table, Row, Col } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../components/button.css";
import { marginBottom } from "../App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import Pagination from "@mui/material/Pagination";
import { TextField } from "@mui/material";
import { apiRequest } from "../components/Config";

export default function PerformersActivity({ perm }) {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchMode, setSearchMode] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [text, setText] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      let url = searchValue
        ? `loginstory/${perm}/${searchValue}`
        : `loginstory/${perm}`;
      try {
        const response = await apiRequest(url, "GET");
        if (Array.isArray(response)) {
          setData(response);
        } else {
          setData([]);
        }
        //console.log("response: ", response);
        //        setData(response);
        if (response.length === 0) setText("Brak danych ...");
        if (response.error == "Brak uprawnien!")
          setText("Brak danych do pokazania");
      } catch (error) {
        setText("Wystąpił błąd podczas pobierania danych.");
      }
    };

    if (userData) fetchData();
  }, [searchMode, userData, searchValue]);

  const paginatedData = Array.isArray(data)
    ? data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
    : [];

  const handleChangePage = (event, page) => {
    setCurrentPage(page);
  };

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 0) {
      setSearchMode(true);
    } else {
      setSearchMode(false);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <Row style={{ marginBottom }}>
          <Col>
            <p className="p5">Historia logowania</p>
          </Col>
          <Col>
            <TextField
              name="user"
              label="Wyszukaj Osobę"
              variant="outlined"
              onChange={(e) => {
                handleSearch(e);
              }}
              fullWidth
            />
          </Col>
        </Row>
        <Row style={{ marginBottom }}>
          <Pagination
            count={Math.ceil(data.length / itemsPerPage)}
            page={currentPage}
            onChange={handleChangePage}
            color="primary"
            variant="outlined"
            shape="rounded"
          />
        </Row>
      </ThemeProvider>
      <div className="table-responsive">
        <Table bordered hover>
          <thead>
            <tr>
              <th className="td-centered" onClick={() => requestSort("id")}>
                ID
              </th>
              <th onClick={() => requestSort("fullName")}>Wykonawca</th>
              <th onClick={() => requestSort("email")}>Data</th>
            </tr>
          </thead>

          {data.length > 0 && userData.userId ? (
            <tbody>
              <tr>
                <td colSpan="2" style={{ textAlign: "center" }}>
                  <h4>{text}</h4>
                </td>
              </tr>
              {paginatedData.map((item, index) => (
                <tr key={index}>
                  <td className="td-centered">
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>
                  <td>{item.fullName}</td>
                  <td>{item.time}</td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  <h4>{text}</h4>
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>
      <Row style={{ marginBottom }}>
        <Pagination
          count={Math.ceil(data.length / itemsPerPage)}
          page={currentPage}
          onChange={handleChangePage}
          color="primary"
          variant="outlined"
          shape="rounded"
        />
      </Row>
    </div>
  );
}
